var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.979,
    height: 17.979,
    viewBox: "0 0 17.979 17.979",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-md-remove-circle-outline",
    "data-name": "Icon ionic-md-remove-circle-outline",
    transform: "translate(-2.875 -2.875)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M11.865,5.089A6.773,6.773,0,1,1,7.073,7.073a6.747,6.747,0,0,1,4.792-1.984m0-1.714a8.49,8.49,0,1,0,8.49,8.49,8.488,8.488,0,0,0-8.49-8.49Z",
    transform: "translate(0 0)",
    fill: "#d81313",
    stroke: "#efefef",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M19.211,18.238H10.477V16.523h8.735Z",
    transform: "translate(-2.979 -5.516)",
    fill: "#d81313",
    stroke: "#efefef",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.c18836bb88b886532fc388d9196a7bbb.svg";
export { ForwardRef as ReactComponent };